import { ApiCall } from '../ApiClient';
import { UserLiteData } from '../ApiTypes';
import { dateTransformer } from '../ApiUtil';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

const info = (accountId: string, userId: string) => get<UserLiteData>({
    path: '/users.info',
    query: { accountId, userId },
    transform: dateTransformer(),
});

const listDeprecated = (accountId: string) => get<UserLiteData[]>({
    path: '/users.list',
    query: { accountId },
    transform: dateTransformer(),
});

type UserListQuerySearchVariation =
    { in: string[] } |
    { like: string } |
    { like?: never, in?: never };

type UserListQuery = UserListQuerySearchVariation & {
    count?: number,
    scope?: string,
};

const userListSearchFrom = (input: UserListQuery) => {
    if ('in' in input) return `in:${input.in.join(',')}`;
    if ('like' in input) return input.like;
    return undefined;
};

export const usersEndpoints = {
    info,
    listDeprecated,
    list: (input: UserListQuery) => get<UserLiteData[]>({
        path: '/users.list2',
        query: {
            search: userListSearchFrom(input),
            count: input.count,
            scope: input.scope,
        },
        transform: dateTransformer(),
    }),
};
